module.exports = __webpack_public_path__ + "media/images/final_page-d53818a8.png";